import SynthEnvelope from '../SynthEnvelope.js';
import Tone from 'tone';

class AmpEnvelope extends SynthEnvelope {
    constructor(sequencerEngine, mixSession, context, input) {
        super(
            sequencerEngine,
            mixSession,
            context,
            undefined,
            undefined,
            undefined,
            new Tone.AmplitudeEnvelope(10, 10, 1, 100));
        
        if (input) {
            input.connect(this.envelope);
        }

        this.envelope.releaseCurve = 'linear';
        this.envelope.attackCurve = 'linear';
        this.envelope.decayCurve = 'linear';
        
        /*
        this.releaseCurve = 'linear';
        this.attackCurve = 'linear';
        this.decayCurve = 'linear';
        */
    }

    dispose() {
        super.dispose();
    }
    connect(out) {
        this.envelope.connect(out);
    }
}

export default AmpEnvelope
